import { render } from "./LoadingIcon.vue?vue&type=template&id=772ea59b"
const script = {}

import exportComponent from "/home/runner/work/cube-viewer/cube-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__